import React from "react";
import {
  GKContent,
  GKLoadingType,
  GKLoading,
  GKCompletedState,
} from "@granular/gds-ux-components";

import { ChildrenProp } from "../types";

const Component: React.FC<
  { useGKContent?: boolean; isLoading?: boolean } & ChildrenProp
> = ({ useGKContent, isLoading = true, children }) => {
  const content = (
    <GKLoading
      isLoading={isLoading}
      overlay
      type={GKLoadingType.Spinner}
      className={`h-100${isLoading ? " my-auto" : ""}`}
      data-qa="gk-loading-container"
    >
      <GKCompletedState>{children}</GKCompletedState>
    </GKLoading>
  );

  if (useGKContent) {
    return <GKContent>{content}</GKContent>;
  }

  return content;
};

export default Component;
